export class PathCheckboxController {
  private status: string;
  private title: string;
  private overdue: boolean;
  private completed: boolean;
  private pendingComplete: boolean;
  private isDetail: boolean;
  private size: string;
  private theme: string;
  private isChecked: boolean;
  private isHidden: boolean;
  private action: () => void;

  updateStyle(): void {
    if (this.overdue && !this.pendingComplete) {
      this.theme = 'red';
    } else if (this.completed) {
      this.theme = 'primary';
    } else {
      this.theme = 'gray-dark';
    }
  }

  preformAction($event: JQueryEventObject) {
    this.stopPropagation($event);
    this.action();
  }

  stopPropagation($event: JQueryEventObject) {
    $event.stopPropagation();
  }

  $onInit(): void {
    this.title = this.title ? this.title : '';
    this.isDetail = this.isDetail ? this.isDetail : false;
    this.size = this.isDetail ? 'large' : 'large-xx';
    this.updateStyle();
  }

  $onChanges(changes: ng.IChangesObject): void {
    this.updateStyle();
  }
}

export class PathCheckboxComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/path_checkbox/path_checkbox.html';
  public controller: any = PathCheckboxController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    status: '<',
    overdue: '<',
    completed: '<',
    pendingComplete: '<',
    title: '<?',
    isDetail: '<?',
    action: '&',
    labelId: '@'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/path_checkbox/path_checkbox.ts